export const imageProvider = (baseApiUrl) => ({
    providers: {
        imageProvider: {
            name: 'imageProvider',
            provider: `${__dirname, '..'}/providers/imageProvider`,
            options: {
                modifiers: {
                    format: 'webp',
                    // quality: 100
                },
                screens: {
                    xs: 320,
                    sm: 640,
                    md: 768,
                    lg: 1024,
                    xl: 1200,
                },
                baseURL: `${baseApiUrl}storage/image/`,
            },
        },
    },
    provider: 'imageProvider',
});
